import { FC, MouseEvent } from 'react'
import { RenderIf } from 'components/RenderIf'
import { CartProduct } from './CartProduct'

import { PaymentProductsContainer, TableDiv } from './styled'
import { ICartProduct } from 'featureSliced/shared/store/generalTypes'
import { ITableCloudItem } from 'featureSliced/shared/store/reducers/QRMenuTableReducer/types'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { IBucketProduct } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'

type CartProps = {
  products?: ICartProduct[]
  isBucket?: boolean
  handleProductClick?: (
    productId: number,
    e: MouseEvent<HTMLElement>,
    product: ICartProduct
  ) => void
  getIsProductSelected?: (product: ITableCloudItem) => boolean
  getAltCount?: (product: ITableCloudItem) => number
  isSplit?: boolean
  children?: any
}

export const Cart: FC<CartProps> = ({
  products,
  isBucket = false,
  handleProductClick,
  getIsProductSelected,
  getAltCount,
  isSplit,
  children,
}) => {
  // Hooks
  const t = useTranslations()

  return (
    <>
      <TableDiv>{isSplit ? t('order.split') : t('order.yourOrder')}</TableDiv>
      <PaymentProductsContainer>
        <RenderIf condition={!!products?.length && !children}>
          {products?.map(
            (elP: ITableCloudItem | ICartProduct | IBucketProduct, i) => (
              <CartProduct
                key={`${elP.uniqueId || elP.itemGuid || elP.productId}_${i}`}
                product={elP}
                isPriceFromStorage={isBucket}
                isSelected={getIsProductSelected?.(elP as ITableCloudItem)}
                altCount={getAltCount?.(elP as ITableCloudItem)}
                handleProductClick={handleProductClick}
              />
            )
          )}
        </RenderIf>
        <RenderIf condition={!!products?.length && children}>
          {children}
        </RenderIf>
      </PaymentProductsContainer>
    </>
  )
}
